module.exports = __webpack_public_path__ + "static/25-835ffa1555ecb67562eb18bc5082faba.jpg";